@if (_url) {
  <img [src]="_url" />
}
<div class="tools">
  <div class="toolbar">
    @if (showEditButton && status === FileUploadStatus.Queued && file) {
      <button mat-icon-button (click)="editClick()">
        <mat-icon class="icon">crop</mat-icon>
      </button>
    }
    @if (showDeleteButton) {
      <button mat-icon-button (click)="deleteClick()">
        <mat-icon class="icon">delete</mat-icon>
      </button>
    }
  </div>
</div>
@if (status !== null && status !== undefined) {
  <glxy-uploader-file-status [status]="status" />
}
